import React, { ReactNode } from 'react';
import { ToggleWrapper } from './ToggleWrapper';
import { ToggledFeature } from './featureToggleService';

export function FubIntegrationToggleWrapper(
  props: { children: ReactNode }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.FUB_CONTACTS_INTEGRATION}>
      {props.children}
    </ToggleWrapper>
  );
}
